import * as React from 'react';
export const wexSvg = React.forwardRef(function wexSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F52746',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm21.26 19.9 2.63-3.9-2.63-3.9h2.02l1.62 2.53 1.62-2.52h2.02L25.91 16l2.63 3.9h-2.02l-1.62-2.3-1.62 2.3h-2.02zm-3.12 0c-2.18 0-4.16-1.7-4.16-3.8 0-2.08 1.98-4 4.16-4a4.13 4.13 0 0 1 3.64 2.58c.06.02-5.1 2.4-5.1 2.4l2.47-3.03s-.23-.21-1.13-.21c-.9 0-2.24 1.08-2.24 2.16s.22 1.08.22 1.08l-.9 1.08 1.35-.43s.67.65 1.57.65 1.35-.22 2.47-1.52h1.58a4.2 4.2 0 0 1-3.93 3.03zM3.46 12.1H5.3v5.12s.23.9 1.04.9c.8 0 1.04-.9 1.04-.9v-5.11h1.85v5.11s.23.9 1.04.9c.8 0 1.04-.9 1.04-.9v-5.11h1.85v5.11c0 1.12-.93 2.67-2.9 2.67-1.96 0-2.65-1.55-2.65-1.55S6.7 19.67 6 19.89c-1.38 0-2.54-1.33-2.54-2.44V12.1z',
      }),
    ),
  );
});
wexSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var wex = {
  category: 'brand',
  colorable: false,
  name: 'wex',
  svg: wexSvg,
};
